(function(){
function highlightRow(config,variantId){
var tbl=document.getElementById('ruco-dims-table-details-' + config.productId);
if(!tbl)return;
var activeDims=(config.dimsMap && config.dimsMap[variantId])|| '';
tbl.querySelectorAll('tr[data-dims]').forEach(function(tr){
if(tr.dataset.dims===activeDims){
tr.className='ruco-dims__row--active';
}else if(!tr.className.includes('soldout')){
tr.className='';
}
});
}
function initBlock(config){
var selId=config.selectedVariantId;
if(selId)highlightRow(config,selId);
document.addEventListener('on:variant:change',function(e){
if(e.detail && e.detail.variant)highlightRow(config,e.detail.variant.id);
});
}
function boot(){
document.querySelectorAll('script[type="application/json"][id^="ruco-dims-data-"]').forEach(function(node){
try{
var config=JSON.parse(node.textContent);
if(config && config.productId)initBlock(config);
}catch(e){}
});
}
if(document.readyState==='loading'){
document.addEventListener('DOMContentLoaded',boot);
}else{
boot();
}
})();